import React, { useContext, useState } from "react";
import { Button, Steps, theme } from "antd";
import { useNavigate } from "react-router";
import { context } from "../context/context";
import { http } from "../services/httpService";
import config from "../services/config.json";
import { toast } from "react-toastify";
import FeedBackFormStepOne from "./../components/FeedBack/FeedBackFormStepOne";
import FeedBackFormStepTwo from "./../components/FeedBack/FeedBackFormStepTwo";
import { NavLink } from "react-router-dom";

const steps = [
    {
        title: "تاریخ و متن شروع و پایان",
        content: <FeedBackFormStepOne />,
    },
    {
        title: "سوالات و گزینه ها",
        content: <FeedBackFormStepTwo />,
    },
];
const EditFeedBack = () => {
    const { token } = theme.useToken();
    // state
    const [current, setCurrent] = useState(0);
    const [loading, setLoading] = useState(false);
    // context
    const {
        feedBackEndDate,
        feedBackEndText,
        feedBackStartDate,
        feedBackStartText,
        setFeedBackStepTwoId,
        feedBackData,
        selectedFeedBackId,
        setFeedBackAnswers,
        setFeedBackData,
        setFeedBackEndDate,
        setFeedBackEndText,
        setFeedBackStartDate,
        setFeedBackStartText,
        feedBackTitle,
    } = useContext(context);
    // functions
    const next = () => {
        setLoading(true);
        http.post(
            `${config.parkopoloApi}/api/Interaction/Feedback1/${selectedFeedBackId}`,
            {
                textStart: feedBackStartText,
                textEnd: feedBackEndText,
                startDate: feedBackStartDate,
                endDate: feedBackEndDate,
                title: feedBackTitle,
            }
        )
            .then((res) => {
                setFeedBackStepTwoId(res.data.result._id);
                setCurrent(current + 1);
                setLoading(false);
            })
            .catch((err) => {
                toast.error("خطایی رخ داد !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    progress: undefined,
                    theme: "colored",
                    style: { fontFamily: "Vazir" },
                });
                console.log(err);
                setLoading(false);
            });
    };
    const navigate = useNavigate();
    const handleSubmit = () => {
        http.post(
            `${config.parkopoloApi}/api/Interaction/Feedback2/${selectedFeedBackId}`,
            {
                data: feedBackData,
            }
        )
            .then((res) => {
                toast.success("نظرسنجی با موفقیت ویرایش شد !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    progress: undefined,
                    theme: "colored",
                    style: { fontFamily: "Vazir" },
                });
                console.log(res.data.success);
            })
            .catch((err) => {
                toast.error("خطایی رخ داد !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    progress: undefined,
                    theme: "colored",
                    style: { fontFamily: "Vazir" },
                });
                console.log(err);
            });
        setFeedBackAnswers([]);
        setFeedBackData([]);
        setFeedBackEndDate();
        setFeedBackEndText();
        setFeedBackStartDate();
        setFeedBackStartText();
        navigate("/feedBack", { replace: true });
    };
    const items = steps.map((item) => ({
        key: item.title,
        title: item.title,
    }));
    const contentStyle = {
        lineHeight: "260px",
        textAlign: "center",
        color: token.colorTextTertiary,
        backgroundColor: token.colorFillAlter,
        borderRadius: token.borderRadiusLG,
        border: `1px dashed ${token.colorBorder}`,
        marginTop: 16,
    };
    return (
        <div style={{ direction: "ltr" }}>
            <Steps current={current} items={items} />
            <div style={contentStyle}>{steps[current].content}</div>
            <div
                style={{
                    marginTop: 24,
                    textAlign: "left",
                    display: "flex",
                    gap: 10,
                }}
            >
                {current < steps.length - 1 && (
                    <Button
                        loading={loading}
                        type="primary"
                        onClick={() => next()}
                        disabled={
                            !feedBackEndDate ||
                            !feedBackEndText ||
                            feedBackEndText === "" ||
                            !feedBackStartText ||
                            feedBackStartText === "" ||
                            !feedBackStartDate
                        }
                    >
                        مرحله بعد
                    </Button>
                )}
                {current === steps.length - 1 && (
                    <Button
                        type="primary"
                        disabled={feedBackData.length === 0}
                        onClick={() => handleSubmit()}
                    >
                        ثبت
                    </Button>
                )}
                {
                    <NavLink to="/feedBack">
                        <Button type="primary" danger>
                            لغو
                        </Button>
                    </NavLink>
                }
            </div>
        </div>
    );
};

export default EditFeedBack;
